import { render, staticRenderFns } from "./IconsTab.vue?vue&type=template&id=2eed22f1&"
import script from "./IconsTab.vue?vue&type=script&lang=js&"
export * from "./IconsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports